<script setup>
import { VueFinalModal } from 'vue-final-modal';
import VfmHeader from 'resources/js/components/VfmHeader.vue';
import { PrimeTvChannels } from '../../constants/prime/tv-channels';

const emit = defineEmits(['close']);
</script>

<template>
    <VueFinalModal
        :esc-to-close="true"
        :click-to-close="true"
        class="prime-modal prime-channels-modal"
    >
        <div class="prime-channels-modal__cont">
            <VfmHeader
                title="Список телеканалов"
                class="prime-modal__header prime-channels-modal__header"
                @close="emit('close')"
            />

            <ul class="prime-channels-modal__body">
                <li v-for="item in PrimeTvChannels" class="prime-channels-modal__item">
                    {{ item.name }}

                    <span v-if="item.isHD" class="prime-channels-modal__hd">HD</span>
                </li>
            </ul>
        </div>
    </VueFinalModal>
</template>

<style lang="scss">
@import 'resources/sass/variables';

.prime-channels-modal {
    .vfm__content {
        max-width: 1200px;
        background: #0F0E0E;
    }

    &__header {
        padding-left: 44px !important;
        background: #0F0E0E;

        .vfm__title {
            width: 100%;
            text-align: center;
            color: #DDAA4C;
        }
    }

    &__cont {
        color: white;
        font-size: 15px;
    }

    &__body {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        padding: 0 36px 36px;

        @media screen and (max-width: 1000px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media screen and (max-width: $mobile-max-width) {
            padding: 0 24px 24px;
            grid-template-columns: 1fr;
        }
    }

    &__item {
        padding: 2px 0;
        font-size: 15px;
        font-weight: $font-weight-semibold;

        &::before {
            content: '•';
            margin-right: 8px;
        }
    }

    &__hd {
        color: #DDAA4C;
    }
}
</style>
